var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBitcoin = function SvgBitcoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.805 8.572A6.499 6.499 0 1 1 .194 5.427a6.499 6.499 0 0 1 12.611 3.145Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.463 6.15c.135-.91-.554-1.4-1.495-1.726l.306-1.234-.746-.187-.297 1.201c-.196-.049-.397-.095-.597-.141l.299-1.21-.745-.187L5.882 3.9a24.754 24.754 0 0 1-.476-.113l.001-.004-1.028-.258-.198.802s.553.127.541.135c.302.076.357.277.348.437l-.348 1.405c.02.006.048.013.077.025l-.025-.006a5.45 5.45 0 0 0-.053-.013l-.488 1.968c-.037.093-.13.231-.342.179.008.01-.541-.137-.541-.137l-.37.86.97.244.32.083.211.055-.308 1.247.744.188.306-1.235c.203.056.4.107.594.155l-.305 1.229.746.187.308-1.245c1.271.242 2.227.144 2.63-1.014.324-.932-.017-1.47-.685-1.82.487-.114.854-.437.952-1.103ZM7.759 8.557c-.211.856-1.54.502-2.149.34l-.145-.038.41-1.653c.05.013.112.027.182.043.63.142 1.919.434 1.702 1.308ZM6.184 6.481c.507.136 1.613.434 1.806-.344.197-.795-.879-1.035-1.404-1.152a6.4 6.4 0 0 1-.153-.035l-.371 1.499.122.032Z",
    fill: "#000"
  })));
};

export default SvgBitcoin;